<div class="flex flex-column h-full min-h-30rem">
  <div class="flex justify-content-between align-items-center p-4 border-bottom-1 surface-border bg-gray-50">
    <h3 class="text-lg font-semibold text-900 m-0">{{ 'chat.context.title' | translate }}</h3>
    <div class="flex flex-column align-items-end gap-1">
      <span class="text-sm text-600 font-medium">{{ getContextSize() }}</span>
      @if (lastUpdated) {
        <span class="text-xs text-500">{{ 'chat.context.updated' | translate:{ date: (lastUpdated | date:'short') } }}</span>
      }
    </div>
  </div>

  <div class="flex-1 flex flex-column overflow-hidden">
    @if (isEmpty) {
      <div class="flex flex-column align-items-center justify-content-center flex-1 p-6 text-center">
        <i class="pi pi-info-circle text-4xl text-500 mb-3"></i>
        <h4 class="text-base font-semibold text-900 m-0 mb-2">{{ 'chat.context.no-context-title' | translate }}</h4>
        <p class="text-sm text-600 m-0 line-height-3">{{ 'chat.context.no-context-message' | translate }}</p>
      </div>
    } @else {
      @if (hasSchema()) {
        <div class="m-3 border-1 surface-border border-round bg-white">
          <div class="flex justify-content-between align-items-center p-4 bg-gray-50 border-bottom-1 surface-border border-top-round">
            <h4 class="text-base font-semibold text-900 m-0 flex align-items-center gap-2">
              <i class="pi pi-database text-primary"></i>
              {{ 'chat.context.schema-information' | translate }}
            </h4>
            <p-tag 
              [value]="'chat.context.fields' | translate:{ count: getSchemaCount() }"
              severity="info"
              class="text-xs">
            </p-tag>
          </div>
          
          <div class="grid p-3 bg-gray-50 border-bottom-1 surface-border font-semibold text-sm text-700">
            <div class="col-6">{{ 'chat.context.field-name' | translate }}</div>
            <div class="col-3">{{ 'chat.context.type' | translate }}</div>
            <div class="col-3">{{ 'chat.context.nullable' | translate }}</div>
          </div>
          
          @for (field of getSchemaFields(); track field.name) {
            <div class="grid p-3 border-bottom-1 border-gray-100 text-sm hover:bg-gray-25 last:border-bottom-none">
              <div class="col-6 font-mono text-900 font-medium">{{ field.name }}</div>
              <div class="col-3 text-purple-600 font-mono font-medium">{{ field.type }}</div>
              <div class="col-3">
                <p-tag 
                  [value]="field.nullable ? ('chat.context.yes' | translate) : ('chat.context.no' | translate)"
                  [severity]="field.nullable ? 'warning' : 'success'"
                  class="text-2xs">
                </p-tag>
              </div>
            </div>
          }
        </div>
      }
      <div class="flex-1 min-h-25rem border-1 surface-border border-round m-3 overflow-hidden" [class.mt-0]="hasSchema()">
        <div class="p-3 bg-gray-50 border-bottom-1 surface-border">
          <h4 class="text-sm font-semibold text-900 m-0 flex align-items-center gap-2">
            <i class="pi pi-code text-600"></i>
            {{ 'chat.context.full-context-data' | translate }}
          </h4>
        </div>
        <ngx-monaco-editor
          [options]="editorOptions"
          [(ngModel)]="formattedContext"
          class="h-full w-full">
        </ngx-monaco-editor>
      </div>
    }
  </div>

  <div class="flex justify-content-between align-items-center p-4 border-top-1 surface-border bg-gray-50">
    <div class="flex gap-3 align-items-center flex-1">
      @if (!isEmpty) {
        <p-button 
          icon="pi pi-copy" 
          [label]="'chat.context.copy' | translate" 
          (onClick)="copyToClipboard()"
          [pTooltip]="'chat.context.copy-tooltip' | translate"
          [outlined]="true">
        </p-button>
      }
    </div>
    
    <div class="flex gap-2 justify-content-end">
      @if (!isEmpty) {
        <p-button 
          icon="pi pi-trash" 
          [label]="'chat.context.clear-context' | translate" 
          (onClick)="clearContext()"
          severity="danger"
          [outlined]="true">
        </p-button>
      }
      <p-button 
        icon="pi pi-times" 
        [label]="'chat.context.close' | translate" 
        (onClick)="close()"
        severity="secondary">
      </p-button>
    </div>
  </div>
</div>